import { NgModule } from '@angular/core';
import { QuestionModule } from '../abstract/question.module';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { ClickOutsideModule } from '../../../../shared';

import { RegularCellModule } from './regular-cell/regular-cell.module';
import { NumberToAlphabetPipe } from './number-to-alphabet.pipe';
import { QuestionTableCheckboxComponent } from './question-table-checkbox.component';
import { HeaderCellModule } from './header-cell/header-cell.module';

@NgModule({
  imports: [
    QuestionModule,
    HeaderCellModule,
    RegularCellModule,
    ClickOutsideModule,
    BsDropdownModule.forRoot()
  ],
  declarations: [
    QuestionTableCheckboxComponent,
    NumberToAlphabetPipe,
  ],
  exports: [
    QuestionModule,
    HeaderCellModule,
    RegularCellModule,
    ClickOutsideModule,
    BsDropdownModule,
    QuestionTableCheckboxComponent, 
    NumberToAlphabetPipe,
  ]
})
export class QuestionTableCheckboxModule {}
